import React from 'react';
import PropTypes from 'prop-types';

import { H3 } from '../../../components';
import { TranslatedCopy } from '../../../intl/TranslatedCopy';

const OrderReturnsStatusDetails = ({
  currentStep,
  returnReason,
  returnComments,
  returnReferenceId,
  totalItems,
  totalQuantity
}) =>
  currentStep > 0 ? (
    <div className='orderReturns__section_status p6-sm border-top'>
      <ul>
        <li>
          <H3>
            <TranslatedCopy id='orderreturns.returnReason' />
          </H3>
          <p>{returnReason}</p>
        </li>
        <li>
          <H3>
            <TranslatedCopy id='orderreturns.returnComments' />
          </H3>
          <p>{returnComments}</p>
        </li>
        <li>
          <H3>
            <TranslatedCopy id='orderreturns.returnReferenceId' />
          </H3>
          <p>{returnReferenceId}</p>
        </li>
        <li>
          <H3>
            <TranslatedCopy id='orderreturns.totalItems' />
          </H3>
          <p>
            <TranslatedCopy id='global.items.value' values={{ amount: totalItems }} />
          </p>
        </li>
        {currentStep > 1 && (
          <li>
            <H3>
              <TranslatedCopy id='orderreturns.totalQuantity.copy' />
            </H3>
            <p>{totalQuantity}</p>
          </li>
        )}
      </ul>
    </div>
  ) : null;

OrderReturnsStatusDetails.propTypes = {
  currentStep: PropTypes.number.isRequired,
  returnReason: PropTypes.string,
  returnComments: PropTypes.string,
  returnReferenceId: PropTypes.string,
  totalQuantity: PropTypes.number,
  totalItems: PropTypes.number
};

OrderReturnsStatusDetails.defaultProps = {
  returnReason: '',
  returnComments: '',
  returnReferenceId: '',
  totalQuantity: 0,
  totalItems: 0
};

export default OrderReturnsStatusDetails;
